export const CONSENT_LEVEL_COOKIE_KEY_BASE = 'AVG-GDPR--consent-level'

export const cookieExpires = {
    ONE_YEAR: 365,
    TWO_YEARS: 2 * 365,
    ONE_MONTH: 30,
}
